import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComplexTooltipComponent } from './complex-tooltip.component';

@NgModule({
  declarations: [ComplexTooltipComponent],
  imports: [CommonModule],
  exports: [ComplexTooltipComponent],
})
export class ComplexTooltipModule {}
